import React from 'react';

export const CheckboxGroup = () => {
  return <div>CheckboxGroup</div>;
};
